import React from 'react'

const contactInfo = props => <div className='contact'>
  <div>
    <p>+52 55 5277 4947</p>
    <p>info@somamexico.org</p>
  </div>
</div>

export default contactInfo